import merge from 'deepmerge';

import { Translations } from '../types';

import common from './common';
import customer from './customer';
import fr from './fr/web-itc.json';
import en from './en/web-itc.json';

const webItc = {
  fr: fr.web_itc,
  en: en.web_itc,
};

export default merge.all<Translations>([common, customer, webItc]);
